/*
 * @Description: 人员盈利信息修改
 * @Author: 杨志航
 * @Date: 2026-08-11 15:08:15
 */

import React, { useState, useEffect } from 'react'
import api from '@/api'
import {
  Form,
  InputNumber,
  message,
} from 'antd'
import BtnGroup from '@/components/BtnGroup'
import { allTrim, filterParams } from '@/utils'

const FormItem = Form.Item

const EditProfit = (props) => {
  const { getFieldDecorator, validateFields, getFieldsValue, setFieldsValue } = props.form
  const { setVisible, editData, getList } = props
  const [saveLoading, setSaveLoading] = useState(false)

  useEffect(() => {
    const { personalCost, personalRevenue, consumeRevenue } = editData
    setFieldsValue({
      personalCost,
      personalRevenue,
      consumeRevenue,
    })
  }, [])

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  const formSubmit = (e) => {
    e.preventDefault()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        const { id } = editData
        vals = filterParams(vals)
        vals = {
          id,
          ...vals,
        }
        setSaveLoading(true)
        api.editProfitReport(vals).then(() => {
          setSaveLoading(false)
          setVisible(false)
          message.success('修改成功')
          getList()
        }).catch(() => setSaveLoading(false))
      }
    })
  }

  return (
    <div>
      <Form onSubmit={formSubmit} {...formItemLayout}>
        <FormItem label="年月">
          {editData.yearMonth || '--'}
        </FormItem>
        <FormItem label="部门">
          {editData.departmentName || '--'}
        </FormItem>
        <FormItem label="员工姓名">
          {editData.staffName || '--'}
        </FormItem>
        <FormItem label="员工编号">
          {editData.staffNo || '--'}
        </FormItem>
        <FormItem label="人员成本">
          {getFieldDecorator('personalCost', {
            rules: [{ required: true, message: '请输入人员成本' }]
          })(
            <InputNumber 
              placeholder="请输入人员成本" 
              style={{ width: '90%'}}
              precision={2}
              step={0.01}
            />
          )}
          <span style={{ marginLeft: 8 }}>元</span>
        </FormItem>
        {(editData.departmentType !== '职能' && editData.personalAttr !== '业务职能') && (
          <>
            <FormItem label="订单业绩">
              {getFieldDecorator('personalRevenue', {
                rules: [{ required: true, message: '请输入订单业绩' }]
              })(
                <InputNumber 
                  placeholder="请输入订单业绩" 
                  style={{ width: '90%'}}
                  precision={2}
                  step={0.01}
                />
              )}
              <span style={{ marginLeft: 8 }}>元</span>
            </FormItem>
            <FormItem label="消耗业绩">
              {getFieldDecorator('consumeRevenue', {
                rules: [{ required: true, message: '请输入消耗业绩' }]
              })(
                <InputNumber 
                  placeholder="请输入消耗业绩" 
                  style={{ width: '90%'}}
                  precision={2}
                  step={0.01}
                />
              )}
              <span style={{ marginLeft: 8 }}>元</span>
            </FormItem>
          </>
        )}
        <BtnGroup onCancel={() => setVisible(false)} loading={saveLoading} />
      </Form>
    </div>
  );
}

export default Form.create()(EditProfit)
